import { useMemo } from 'react';
import { useGetTripStopTypesQuery } from '../../../../../../store/services/tripsApi';
import { IDEA_STOP_TYPE_OPTIONS, IdeaStopType } from '../../../../../../types/ideaStop.types';

export const useIdeaStopTypes = () => {
  const { data: tripStopTypesData, isLoading, error } = useGetTripStopTypesQuery();

  const ideaStopTypes = useMemo((): IdeaStopType[] => {
    if (tripStopTypesData?.types) {
      return tripStopTypesData.types;
    }
    return IDEA_STOP_TYPE_OPTIONS;
  }, [tripStopTypesData]);

  const hasTypes = ideaStopTypes.length > 0;

  return {
    ideaStopTypes,
    isLoading,
    error,
    hasTypes,
  };
};
